import { createContext, useMemo, type FC, type ReactNode } from 'react'
import { graphql, useStaticQuery } from 'gatsby'

import { mapAllProducts, Product } from 'data/product'

export const ProductsContext = createContext<Product[]>([])

const ProductsProvider: FC<{
  children: ReactNode
}> = ({ children }) => {
  const data = useStaticQuery<Queries.allProductsQuery>(graphql`
    query allProducts {
      allShopifyProduct {
        nodes {
          description
          handle
          id
          title
          priceRangeV2 {
            minVariantPrice {
              amount
              currencyCode
            }
            maxVariantPrice {
              amount
              currencyCode
            }
          }
          variants {
            nodes {
              id
              price {
                amount
                currencyCode
              }
              title
              image {
                url
              }
              theme {
                value
              }
            }
          }
          images {
            nodes {
              url
            }
          }
        }
      }
    }
  `)

  const products = useMemo(() => mapAllProducts(data), [data])

  return (
    <ProductsContext.Provider value={products}>
      {children}
    </ProductsContext.Provider>
  )
}

export default ProductsProvider
